import { Component, Inject } from "@angular/core";
import { DIALOG_DATA } from '../../../../services/dialog.service';
import { MatDialogRef } from '@angular/material';
import { TaskMetadataC } from '../../../../module/calendar/full-calendar/classes/metadata/task-metadata';
import { JobMetadataC } from '../../../../module/calendar/full-calendar/classes/metadata/job-metadata';
import { ProjectTaskCalendarEventMetadata } from '../../../../module/calendar/full-calendar/classes/metadata/project-task-metadata';

@Component({
  selector: 'task-calendar-dialog',
  template: `<task-calendar [mode]="'dialog'" [data]="data" (closeParentDialog)="closeDialog()" (onSetRefreshActivities)="markAsRefresh($event)" appendTo="body"></task-calendar>`,
})
export class TaskCalendarDialogComponent {

  public bRefresh: boolean = false;

  constructor(
    protected dialogRef: MatDialogRef<TaskCalendarDialogComponent>,
    @Inject(DIALOG_DATA) public data: TaskCalendarDialogData,
  ) { }

  markAsRefresh(event: boolean) {
    this.bRefresh = event;
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}

export type TaskCalendarDialogData = TaskMetadataC | JobMetadataC | ProjectTaskCalendarEventMetadata;